<template>
    <div class="tip-dialog-container" @mouseenter="showTipBox" @mouseleave="hideTipBox" @click="hideTipBox">
        <slot />
        <div v-if="isHovered" class="tipbox">
            {{ message }}
        </div>
        <span v-if="isHovered" class="slot-arrow"></span>
    </div>
</template>

<script>
export default {
    name: "TipDialog",
    props: {
        message: {
            type: String,
            required: true,
            default: "Mensagem de dialogo",
        }
    },
    data() {
        return {
            isHovered: false, //false
        };
    },
    methods: {
        showTipBox() {
            this.isHovered = true;
        },
        hideTipBox() {
            this.isHovered = false; //false
        }

    }
};
</script>

<style scoped>
.tip-dialog-container {
    user-select: none;
    position: relative;
    display: inline-block;
}

.slot-arrow {
    position: absolute;
    top: 48%;
    right: 100%;
    transform: translateX(-50%);
    width: 15px;
    height: 15px;
    rotate: 45deg;
    background-color: #1976d2;
}

.tipbox {
    position: absolute;
    top: 9%;
    right: -38%;
    transform: translateX(-50%);
    background-color: #1976d2;
    border: 1px solid #b0c4de transparent;
    border-radius: 5px;
    padding: 5px;
    font-family: Arial, sans-serif;
    font-size: 15px;
    color: #FFFFFF;
    z-index: 1000;
    white-space: normal;
    overflow: hidden;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
}
</style>